/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ZeyoIaConversationPaginator } from '../interfaces/zeyo-ia-conversations';

const BASE_URL = `${environment.apiUrl}/ia-conversation`;

@Injectable({
	providedIn: 'root'
})
export class ZeyoIaConversationsService {
	constructor(private _authenticationService: AuthenticationService, private _http: HttpClient) {}

	// GET METHODS
	getConversationIds(): Observable<ZeyoIaConversationPaginator> {
		const URL = `${BASE_URL}/by-external-unique-id/${this._authenticationService.currentUser.user.sub}`;
		return this._http.get<ZeyoIaConversationPaginator>(URL);
	}
	// END GET METHODS
}
